import RouteTemplate from "ember-route-template";
import ProxyviewsCalculator from "../components/proxyviews-calculator";

export default RouteTemplate(
  <template>
    <div class="proxyviews-calculator-route-container">
      <ProxyviewsCalculator @data={{@model}} />
    </div>
  </template>
);
